<template>
  <div>
    <el-dialog
      append-to-body
      title="详情"
      :visible.sync="visible"

      width="50%"
    >
      <div  style="overflow-x: hidden;height: 650px">
        <div style="margin: 10px">
          <div v-for="(library,index) in libraryList" style="margin-bottom: 5px">
            <div>
              <span>{{ index + 1 }}.</span>
              <span
                v-if="library.questionType==''|| library.questionType ==undefined"></span>
              <el-tag size="mini" v-else-if="library.questionType===1">单选</el-tag>
              <el-tag size="mini" v-else-if="library.questionType===3" style="display: inline-block">
                判断
              </el-tag>
              <el-tag size="mini" v-else-if="library.questionType===2" style="display: inline-block">
                多选
              </el-tag>
              <span>{{ library.questionStemContent }}</span>
            </div>
            <div style="margin-top: 20px">
              <!-- 单选与判断-->
              <div v-if="library.questionType===1||library.questionType===3">
                <!--              <a :id="library.id" class="item-title-a"></a>-->
                <el-radio-group disabled v-model="library.checkStatus">
                  <el-row
                    class="row"
                    v-for="(option, index3) in library.answerList"
                    :key="index3"
                  >
                    <el-radio :label="index3 + 1"
                    >{{
                        index3 == 0
                          ? "A"
                          : index3 == 1
                          ? "B"
                          : index3 == 2
                            ? "C"
                            : index3 == 3
                              ? "D"
                              : index3 == 4
                                ? "E"
                                : index3 == 5
                                  ? "F"
                                  : index3 == 6
                                    ? "E"
                                    : "G"
                      }}. <span class="answer" v-html="option.quetionAnswer"></span
                      ></el-radio>
                  </el-row>
                </el-radio-group>
              </div>
              <div v-if="library.questionType===2" class="formView">
                <el-row
                  class="row"
                  v-for="(option, index3) in library.answerList"
                  :key="index3"
                >
                  <el-checkbox disabled
                    v-model="option.checkStatus"
                    :true-label="0"
                    :false-label="1"
                  >{{
                      index3 == 0
                        ? "A"
                        : index3 == 1
                        ? "B"
                        : index3 == 2
                          ? "C"
                          : index3 == 3
                            ? "D"
                            : index3 == 4
                              ? "E"
                              : index3 == 5
                                ? "F"
                                : index3 == 6
                                  ? "E"
                                  : "G"
                    }}. <span class="answer" v-html="option.quetionAnswer"></span
                    ></el-checkbox>
                </el-row>


              </div>
              <!-- 解析-->
              <div style="margin: 10px">
                <div>
                  用户答题：
                  <p v-for="(item,index) in library.answerList">
                    <span v-if="item.checkStatus===0" style="color: red">{{ item.quetionAnswer }} </span>
                  </p>
                </div>
               <div>
                 正确答案:
                 <p v-for="(item,index) in library.answerList">
                   <span v-if="item.trueStatus===0" style="color: #13ce66">{{ item.quetionAnswer }} </span>
                 </p>
               </div>
                <p>
                  解析：
                  <span>
                   {{ library.questionAnalysis === null ? '暂无解析' : library.questionAnalysis }}
                  </span>
                </p>
              </div>

            </div>


          </div>


        </div>

      </div>

    </el-dialog>
  </div>
</template>


<script>
export default {
  data() {
    return {
      libraryList: [],
      visible: false,
    }
  },
  methods: {
    show(data) {


      data.forEach(v => {
        if (v.questionType == 1 || v.questionType == 3) {
          v.answerList.forEach((v3, index3) => {
            let index = index3 + 1;
            console.log(v.answerTrue == v3.id)
            console.log(index3)
            if (v3.checkStatus == 0) {
              v.checkStatus = index;
              return false;
            }
          });
        }
      })
      console.log(data)
      this.libraryList = data;
      this.visible = true;
    }
  }
}
</script>


<style lang='scss' scoped>

</style>



// WEBPACK FOOTER //
// src/components/classTestRecord/detail.vue